<div class="mat-list-item-content">
  <div class="mat-list-item-ripple" mat-ripple
       [matRippleTrigger]="_getHostElement()"
       [matRippleDisabled]="_isRippleDisabled()">
  </div>

  <ng-content select="[mat-list-avatar], [mat-list-icon], [matListAvatar], [matListIcon]">
  </ng-content>

  <div class="mat-list-text"><ng-content select="[mat-line], [matLine]"></ng-content></div>

  <ng-content></ng-content>
</div>
